// extracted by mini-css-extract-plugin
export default {"clue_frame":"ClueList_clue_frame__Zgdcu","frame":"ClueList_frame__0W5TP","top":"ClueList_top__zN+2W","body":"ClueList_body__XmxML","bottom":"ClueList_bottom__A6hLD"};